exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Link {\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  font-size: 20px;\n  line-height: 30px;\n  background: none;\n  border: none; }\n", ""]);

// exports
